<!--

      This view allows to get inspired by scrolling through
      a selection of grouped recipes. Recipes can be added 
      to the cart with a click of a button.

 -->

<template>
  <Page title='Rezepte für dich' :disableSwipeBack="true" :hideback="true">
    <AddMealsToPlan />
    <Recipes />
  </Page>
</template>

<script>
import Page from '@/components/Page.vue'
import Recipes from '@/components/Recipes.vue'
import AddMealsToPlan from '@/components/AddMealsToPlan.vue'

export default {
  name: 'recipestab',
  components: {
    Page,
    Recipes,
    AddMealsToPlan
  },
  mounted () {
    this.$store.dispatch('save', { key: 'replaceme', value: null })
  }
}
</script>
